// extracted by mini-css-extract-plugin
export var addToCard = "addToCard-module--addToCard--4D4jz";
export var atcBtn = "addToCard-module--atcBtn--gvLqT";
export var atcMobileContainer = "addToCard-module--atcMobileContainer--qL+rX";
export var atcPrice = "addToCard-module--atcPrice--I7k3k";